




import React from "react";
import ServiceCard from "./ServiceCard";
import BookingForm from "./BookingForm";

// Sample data
const packages = [
  { 
    title: "Basic Health Package", 
    price: "₹1999.00", 
    desc: "Comprehensive basic health checkup",
    img: require("../assets/pack1.jpg")
  },
  { 
    title: "Pune Comprehensive Package", 
    price: "₹2,499.00", 
    desc: "Full health checkup with advanced tests",
    img: require("../assets/pack01.jpg")
  },
  { 
    title: "Master Full Body Checkup", 
    price: "₹1,999.00", 
    desc: "Male full body package",
    img: require("../assets/pack3.jpg")
  },
  { 
    title: "Master Full Body Checkup", 
    price: "₹2500.00", 
    desc: "Customized wellness package",
    img: require("../assets/pack5.jpg")
  },
  { 
    title: "Vasant Wellness Profile", 
    price: "₹1,199.00", 
    desc: "Customized wellness package",
    img: require("../assets/packages4.jpg")
  },
  { 
    title: "Diabetes 1 Year Package", 
    price: "₹999.00", 
    desc: "6 Sugar Test and 2 HBa1c In 12 Month,",
    img: require("../assets/card6.png")
  }
];

const labTests = [
  { title: "HbA1c Test", price: "₹500.00", desc: "Blood sugar control test", img: require("../assets/hba1c2.jpg") },
  { title: "Blood Collection from Home", desc: "Contact for price", img: require("../assets/home.png") },
  { title: "Dengue Profile", price: "₹1,200.00", desc: "Rapid dengue testing", img: require("../assets/dengue.jpg") },
  { title: "Complete Blood Count", price: "₹200.00", desc: "CBC full panel", img: require("../assets/cbt.jpg") },
  { title: "Thyroid Function Test", price: "₹500.00", desc: "T3, T4, TSH", img: require("../assets/tft2.jpg") },
  { title: "Blood Sugar Test", price: "₹100.00", desc: "Glucose fasting & PP", img: require("../assets/bst.png") },
  { title: "Rapid Malaria Test", price: "₹250.00", desc: "Quick malaria check", img: require("../assets/mt2.jpg") },
  { title: "Blood Group", price: "₹100.00", desc: "ABO & Rh factor", img: require("../assets/bg.jpg") },
];

export default function Services() {
  const [open, setOpen] = React.useState(false);
  const [selectedTest, setSelectedTest] = React.useState("");

  const openBooking = (testName) => {
    setSelectedTest(testName);
    setOpen(true);
  };

  return (
    <section id="services" className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 space-y-12">

        {/* ⭐ Main Services Heading */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-red-600 tracking-wide">
            Our Services
          </h1>
          <p className="text-gray-600 mt-2 text-lg">
            Choose from our wide range of Lab Tests & Health Packages
          </p>
        </div>

        {/* Lab Tests */}
        <div>
          <h2 className="text-3xl font-bold text-red-600 mb-6">Lab Tests</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {labTests.map((item) => (
              <ServiceCard key={item.title} item={item} openBooking={openBooking} />
            ))}
          </div>
        </div>

        {/* Packages */}
        <div>
          <h2 className="text-3xl font-bold text-red-600 mb-6">Packages</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {packages.map((item) => (
              <ServiceCard key={item.title} item={item} openBooking={openBooking} />
            ))}
          </div>
        </div>

      </div>

      {/* Popup Form */}
      <BookingForm 
        open={open}
        onClose={() => setOpen(false)}
        testName={selectedTest}
      />
    </section>
  );
}
